<div fxLayoutAlign.gt-md="space-between center" fxLayout.lt-md="column">
  <h1>Pesquisa de Departamento</h1>
</div>

<form [formGroup]="form">
  <mat-form-field appearance="outline" fxFill>
    <mat-icon matSuffix (click)="filtrar()">search</mat-icon>
    <mat-label>Pesquisar por ID</mat-label>
    <input
      matInput
      formControlName="id"
      type="search"
      mask="99999999"
      (keydown.enter)="filtrar()"
      maxlength="8"
      #input />
  </mat-form-field>
</form>

<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
  <mat-tab label="Responsável oficial">
    <ng-template matTabContent>
      <mat-card class="info" *ngIf="getDataResponsavelOficial() === 'sem_resultado'">
        <p>Nenhum resultado encontrado para: {{ lastSearch }}</p>
      </mat-card>

      <pre *ngIf="tabStateResponsavelOficial === 'pronto'">{{ dataResponsavelOficial | json }}</pre>
    </ng-template>
  </mat-tab>

  <mat-tab label="Responsável vigente">
    <ng-template matTabContent>
      <mat-card class="info" *ngIf="getDataResponsavelVigente() === 'sem_resultado'">
        <p>Nenhum resultado encontrado para: {{ lastSearch }}</p>
      </mat-card>

      <pre *ngIf="tabStateResponsavelVigente === 'pronto'">{{ dataResponsavelVigente | json }}</pre>
    </ng-template>
  </mat-tab>

  <mat-tab label="Assessor vigente">
    <ng-template matTabContent>
      <mat-card class="info" *ngIf="getDataAssessorVigente() === 'sem_resultado'">
        <p>Nenhum resultado encontrado para: {{ lastSearch }}</p>
      </mat-card>

      <pre *ngIf="tabStateAssessorVigente === 'pronto'">{{ dataAssessorVigente | json }}</pre>
    </ng-template>
  </mat-tab>
</mat-tab-group>
